import { faCircleXmark } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useRef, useState } from 'react';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Select from 'react-select';
import Docmnt from "../../assets/images/file.svg";
import CargoLogo from '../../assets/images/logocargo.png';
import Completed from '../../assets/images/Completed.svg';

import { withRFSToken, withEmailToken } from '../../Services/axios.js';
import { GETDESTINATION, GETMISSINGDATA, MISSINGSTATION, UPDATEMISSING } from '../../Utils/conts.js';
import { toast } from 'react-toastify';
import { useUserCheckQuery } from '../../redux/services/Auth.js';

const SubmitForm = () => {
    const isMounted = useRef(false);
    const [formData, setFormData] = useState({ recovery_status: '' });
    const [getDestination, setGetDestination] = useState([]);
    const [files, setFiles] = useState([]);
    const fileInputRef = useRef(null);
    const [base64Files, setBase64Files] = useState([]);
    const [selectedRowId, setSelectedRowId] = useState(null);
    const [showModalUpload, setShowModalUpload] = useState(false);
    const [finishStep, setFinishStep] = useState(false);
    const [userDetails, setUserDetails] = useState();

    let keyType = null;

    const [userType, setUserType] = useState(''); //handler
    const [missingData, setMissingData] = useState({}); //handler
    const { data: myData } = useUserCheckQuery('', {
        // skip: pageDetails.pagesize === 0,
    });
    useEffect(() => {
        if (myData?.response_data) {
            setUserDetails(myData?.response_data);
        }
    }, [myData]);

    const getMissingData = async (encCode) => {
        const email = localStorage.getItem('CEmail');
        const token = localStorage.getItem('EMAIL');
        try {
            const res = await withEmailToken.post(GETMISSINGDATA, { email_approval_token: userDetails?.email_id, email: userDetails?.email, data: encCode })
                .then(function (res) {
                    if (res.data.response_code === 200) {
                        const innerData = res.data.response_data;
                        setMissingData(innerData);
                    } else {
                        toast.error(res.data.response_msg)
                    }
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }
    const getMissingStation = async () => {
        try {
            const email = localStorage.getItem('CEmail');
            const token = localStorage.getItem('EMAIL');
            const res = await withEmailToken.post(MISSINGSTATION, { email_approval_token: token, email: email },
                // {
                //     headers: {
                //         'Content-Type': 'application/json',
                //         'email_approval_token': token,
                //         'email': email  // Set the email in the request headers
                //     }
                // }
            )
                .then(function (res) {
                    if (res.data.response_code === 200) {
                        const innerData = res.data.response_data;
                        const transformedData = innerData ? innerData.map(item => ({
                            value: item.port_code,
                            label: item.port_code,
                            address: item.address,
                            station_id: item.station_id
                        })) : [];
                        setGetDestination(transformedData);
                    } else {
                        toast.error(res.data.response_msg)
                    }
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }

    useEffect(() => {
        if (isMounted.current) return;
        // fetchDestination();
        setUserType(localStorage.getItem('User_Type'));
        getMissingStation()
        const cData = localStorage.getItem('CData');
        if (cData) {
            getMissingData(cData)
        }
        isMounted.current = true;
    }, []);

    // Convert the decrypted bytes into a readable format (usually UTF-8)
    // const decryptedData = decrypted.toString(CryptoJS.enc.Utf8);


    let recoveryStatus = [];
    if (userType === 'H') {
        recoveryStatus = [
            { label: 'ULD Found', value: '1' },
            { label: 'ULD Lost', value: '2' },
            { label: 'Departed on flight/truck', value: '3' },
            { label: 'Transferred to other Handler', value: '4' },
            { label: 'Other', value: '7' },
        ]
    } else {
        recoveryStatus = [
            { label: 'ULD Found', value: '1' },
            { label: 'ULD Lost', value: '2' },
            { label: 'Returend to Handler', value: '5' },
            { label: 'Delivered to Extrernal Party', value: '6' },
            { label: 'Other', value: '7' },
        ]
    }
    const optionHowFound = [
        { label: 'Inventory Check', value: 'Inventory Check' },
        { label: 'Returned from another warehouse', value: 'Returned from another warehouse' },
        { label: 'Returned from another Handler', value: 'Returned from another Handler' },
        { label: 'Other', value: 'Other' },
    ];
    const optionCondition = [
        { label: 'Serviceable', value: 'Serviceable' },
        { label: 'Damaged', value: 'Damaged' },
    ];
    const cirLoss = [
        { label: 'Theft', value: 'Theft' },
        { label: 'Mishandling', value: 'Mishandling' },
        { label: 'Other', value: 'Other' },
    ];

    const conLoss = [
        { label: 'Yes', value: 'Yes' },
        { label: 'No', value: 'No' },
    ];

    const TruckFlightList = [
        { label: 'Flight', value: 'Flight' },
        { label: 'Truck', value: 'Truck' },
    ];
    const deliverypurpose = [
        { label: 'Further Transport', value: 'Further Transport' },
        { label: 'Build up', value: 'Build up' },
        { label: 'Other', value: 'Other' },
    ];

    // const onChangesData = (event) => {
    //     const { name, value } = event.target;
    //     setFormData(prevState => ({
    //         ...prevState,
    //         [name]: value
    //     }));
    // }
    const onChangesData = (event) => {
        const { name, value } = event.target;

        // Split the name if it's a nested field
        const nameParts = name.split('.');

        setFormData(prevState => {
            // Create a copy of the previous formData
            const updatedFormData = { ...prevState };

            // If name contains nested fields (like contact_person.name)
            if (nameParts.length > 1) {
                let currentLevel = updatedFormData;

                // Traverse the levels until the second to last key
                for (let i = 0; i < nameParts.length - 1; i++) {
                    const part = nameParts[i];

                    // Ensure the current level is an object before moving to the next
                    if (!currentLevel[part]) {
                        currentLevel[part] = {};
                    }

                    currentLevel = currentLevel[part];
                }

                // Update the final field with the value
                currentLevel[nameParts[nameParts.length - 1]] = value;
            } else {
                // If it's not a nested field, update directly
                updatedFormData[name] = value;
            }

            return updatedFormData;
        });
    };


    // const fetchDestination = async () => {
    //     try {

    //         const res = await withRFSToken.post(GETDESTINATION, {})
    //             .then(function (res) {
    //                 const innerData = res.data.response_data;
    //                 const transformedData = innerData ? innerData.map(item => ({
    //                     value: item.port_code,
    //                     label: item.port_code,
    //                     address: item.address,
    //                     station_id: item.station_id
    //                 })) : [];
    //                 setGetDestination(transformedData);
    //             });

    //     } catch (error) {
    //         console.error('Error fetching data:', error);
    //     }
    // };

    const handleDrop = (e) => {
        e.preventDefault();
        const droppedFiles = Array.from(e.dataTransfer.files);
        setFiles((prevFiles) => [...prevFiles, ...droppedFiles]);
        getBase64(droppedFiles[0]);
    };

    const handleDragOver = (e) => {
        e.preventDefault();
    };

    // useEffect(() => {
    //     if (isMounted.current) return;
    //     // fetchDestination();
    //     isMounted.current = true;

    // }, []);

    const handleDeleteFile = (index) => {
        setFiles((prevFiles) => {
            const newFiles = [...prevFiles];
            newFiles.splice(index, 1);
            return newFiles;
        });
        // base64Files.splice(index, 1);
        setBase64Files((prevBase64Files) => {
            const newBase64Files = [...prevBase64Files];
            newBase64Files.splice(index, 1);

            // Update local storage
            setFormData((prevFormData) => {
                const newFormData = { ...prevFormData, base64Files: newBase64Files };
                const keyData = JSON.parse(localStorage.getItem(keyType)) || {};
                keyData.Form = newFormData;
                // if (keyData.ULD) {
                //     localStorage.setItem(keyType, JSON.stringify({ ULD: keyData.ULD, Form: newFormData }));
                // } else {
                //     localStorage.setItem(keyType, JSON.stringify({ Form: newFormData }));
                // }
                return newFormData;
            });

            return newBase64Files;
        });
    };

    const handleBrowseFiles = (e) => {
        e.preventDefault();
        fileInputRef.current.click();
    };

    function getBase64(file) {
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
            setBase64Files((prevBase64Files) => [...prevBase64Files, reader.result]);
        };
        reader.onerror = function (error) {
            console.log('Error: ', error);
        };
    }


    const handleFileChange = (e) => {
        const selectedFiles = Array.from(e.target.files);
        const filesWithBase64 = [];
        let filesProcessed = 0;

        const existingData = JSON.parse(localStorage.getItem(keyType)) || {};
        const existingBase64Files = existingData.Form?.base64Files || [];

        selectedFiles.forEach((file) => {
            const reader = new FileReader();
            reader.onloadend = () => {
                filesWithBase64.push({ file, base64: reader.result, file_name: file.name });
                filesProcessed += 1;
                if (filesProcessed === selectedFiles.length) {
                    const newFiles = filesWithBase64.map((obj) => obj.file);
                    // const newBase64Files = filesWithBase64.map((obj) => obj.base64);
                    const newBase64Files = filesWithBase64.map((obj) => ({ base64: obj.base64, file_name: obj.file_name }));
                    const mergedBase64Files = [...existingBase64Files, ...newBase64Files];
                    // setFiles(newFiles);
                    setFiles((prevFiles) => [...prevFiles, ...newFiles]);
                    setBase64Files(mergedBase64Files);
                    setFormData((prevFormData) => {
                        const newFormData = { ...prevFormData, files: newFiles, base64Files: mergedBase64Files };
                        const keyData = JSON.parse(localStorage.getItem(keyType)) || {};
                        keyData.Form = newFormData;
                        // if (keyData.ULD) {
                        //     localStorage.setItem(keyType, JSON.stringify({ ULD: keyData.ULD, Form: newFormData }));
                        // } else {
                        //     localStorage.setItem(keyType, JSON.stringify({ Form: newFormData }));
                        // }
                        return newFormData;
                    });
                }
            };
            reader.readAsDataURL(file);
        });
    };
    const imageUpload = () => {
        setFormData(prevFormData =>
            prevFormData.map(item => {
                if (item.uid === selectedRowId) {
                    return { ...item, files: files, base64Files: base64Files };
                }
                return item;
            })
        );
        setShowModalUpload(false);
    };

    const handleSubmitForm = async () => {
        const updatedFormData = {
            ...formData,
            missing_id: missingData.missing_id,
            email_approval_token: localStorage.getItem('EMAIL'), email: localStorage.getItem('CEmail')
        };
        try {
            const res = await withEmailToken.post(UPDATEMISSING, updatedFormData)
                .then(function (res) {
                    if (res.data.response_code === 200) {
                        const innerData = res.data.response_data;
                        toast.success(res.data.response_msg);
                        setFinishStep(true);
                    } else {
                        toast.error(res.data.response_msg)
                    }

                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }

    return (
        <div className="recovery_from">
            {console.log('userType', formData)}
            <div className='text-center'>
                <img src={CargoLogo} alt='' />
                {!finishStep ?
                    <p className='mt-3 mb-4'>
                        Please fill up the form below and provide as much information as possible to help ensure the smooth recovery of the ULD, <br />
                        When you're done, click the submit button at the bottom of the screen.
                    </p>
                    : <div className='mtvh'></div>}
            </div>
            {finishStep ? (
                <div className='w-100 d-flex justify-content-center align-items-center'>
                    <div className='complt'>
                        <img src={Completed} alt='' />
                        <h3>Thank you!</h3>
                        <p>Submit was successful</p>
                    </div>
                </div>
            ) : (
                <>
                    <Row>
                        <Col sm='4'>
                            <div className='missing_info'>
                                <h4>ULD Information</h4>
                                <p>Overview of ULD Specifications</p>
                                <ul>
                                    <li>
                                        <span>ULD Number</span> <span>:   {missingData?.uld_information?.uld_number}</span>
                                    </li>
                                    <li>
                                        <span>Condition</span> <span>:   {missingData?.uld_information?.condition}</span>
                                    </li>
                                    <li>
                                        <span>Last Seen Location</span> <span>:  {missingData?.uld_information?.last_seen_location}</span>
                                    </li>
                                    <li>
                                        <span>Last Seen Date</span> <span>:  {missingData?.uld_information?.last_seen_date}</span>
                                    </li>
                                </ul>
                            </div>

                            <div className='missing_info mb-0 pl_height'>
                                <h4>Movement Information</h4>
                                <p>Last Know ULD Movement Information</p>
                                <ul>
                                    <li>
                                        <span>Last Movement Type</span> <span>:    {missingData?.movement_information?.operation_type}</span>
                                    </li>
                                    {['UCM In', 'UCM Out'].includes(missingData?.movement_information?.operation_type) ?
                                        <>
                                            <li><span>Truck/Flight </span> <span>: {missingData?.movement_information?.flight_or_truck === 'F' ? 'Flight' : 'Truck'}</span></li>
                                            <li><span>Flight Number </span> <span>: {missingData?.movement_information?.flight_number}</span></li>
                                            <li><span>Flight Date </span> <span>: {missingData?.movement_information?.flight_date}</span></li>
                                            <li><span>Origin </span> <span>: {missingData?.movement_information?.origin}</span></li>
                                            <li><span>Origin Handler Name</span> <span>: {missingData?.movement_information?.origin_handler}</span></li>
                                            <li><span>Destination</span> <span>: {missingData?.movement_information?.destination}</span></li>
                                            <li><span>Destination Handler Name</span> <span>: {missingData?.movement_information?.destination_handler}</span></li>
                                            <li><span>Registration Number</span> <span>: {missingData?.movement_information?.flight_reg_number}</span></li>
                                        </>
                                        : (missingData?.movement_information?.operation_type === 'LUC Out' ?
                                            <>
                                                <li><span>Transfer Date</span> <span>: {missingData?.movement_information?.operation_date}</span></li>
                                                <li><span>Control Receipt Number</span> <span>: {missingData?.movement_information?.control_receipt_no}</span></li>
                                                <li><span>Transfer Point</span> <span>: {missingData?.movement_information?.transfer_point}</span></li>
                                                <li><span>Transferred By</span> <span>: {missingData?.movement_information?.transferred_by}</span></li>
                                                <li><span>Final Destination</span> <span>: {missingData?.movement_information?.luc_final_dest}</span></li>
                                                <li><span>Received By</span> <span>: {missingData?.movement_information?.received_by}</span></li>
                                            </>
                                            : (missingData?.movement_information?.operation_type === 'LUC In' ?
                                                <>
                                                    <li><span>Return Date</span> <span>: {missingData?.movement_information?.operation_date}</span></li>
                                                    <li><span>Control Receipt Number</span> <span>: {missingData?.movement_information?.control_receipt_no}</span></li>
                                                    <li><span>Return To</span> <span>: {missingData?.movement_information?.return_to}</span></li>
                                                    <li><span>Transfer Point</span> <span>: {missingData?.movement_information?.transfer_point}</span></li>
                                                    <li><span>Returned By</span> <span>: {missingData?.movement_information?.returned_by}</span></li>
                                                </>
                                                : (['Station Transfer', 'Transfer Request'].includes(missingData?.movement_information?.operation_type) ?
                                                    <>
                                                        <li><span>Transfer Date</span> <span>: {missingData?.movement_information?.operation_date}</span></li>
                                                        <li><span>Control Receipt Number</span> <span>: {missingData?.movement_information?.control_receipt_no}</span></li>
                                                        <li><span>Transfer Point</span> <span>: {missingData?.movement_information?.transfer_point}</span></li>
                                                        <li><span>Transferred By</span> <span>: {missingData?.movement_information?.transferred_by}</span></li>
                                                        <li><span>Final Destination</span> <span>: {missingData?.movement_information?.luc_final_dest}</span></li>
                                                        <li><span>Received By</span> <span>: {missingData?.movement_information?.received_by}</span></li>
                                                    </>
                                                    : (['Repair In', 'Repair Out'].includes(missingData?.movement_information?.operation_type) ?
                                                        <>
                                                            <li><span>Repair Name</span> <span>: {missingData?.movement_information?.repair_name}</span></li>
                                                            <li><span>Repair Station</span> <span>: {missingData?.movement_information?.repair_station}</span></li>
                                                            <li><span>Repair In</span> <span>: {missingData?.movement_information?.operation_date}</span></li>
                                                        </>
                                                        : (missingData?.movement_information?.operation_type === 'Lease Out' ?
                                                            <>
                                                                <li><span>Station Out</span> <span>: {missingData?.movement_information?.destination}</span></li>
                                                            </>
                                                            : (missingData?.movement_information?.operation_type === 'SCM' ?
                                                                <>
                                                                    <li><span>Date of Check</span> <span>: {missingData?.movement_information?.operation_date}</span></li>
                                                                    <li><span>Destination</span> <span>: {missingData?.movement_information?.destination}</span></li>
                                                                    <li><span>Destination Handler Name</span> <span>: {missingData?.movement_information?.destination_handler}</span></li>
                                                                </>
                                                                : ''
                                                            )
                                                        )
                                                    )
                                                )
                                            )
                                        )
                                    }

                                </ul>


                            </div>

                        </Col>
                        <Col sm='4'>
                            <div className='missing_info h-100'>
                                <h4>Recovery Information</h4>
                                <p>Provide ULD Recovery Details</p>

                                <div className='charter_from '>

                                    <div className='recovery_status'>
                                        <Form.Group controlId="exampleForm.ControlInput1" className='col-md-6' >
                                            <Form.Label>Recovery Status</Form.Label>
                                            <Select
                                                options={recoveryStatus}
                                                placeholder="Recovery Status"
                                                className='rfs_autoslct'
                                                name="recovery_status"
                                                onChange={(selected) => {
                                                    const resetAdditionalInfo = selected.value === '1' ? { date_time: '', how_found: '', condition: '' } :
                                                        selected.value === '2' ? { cir_loss: '', conf_loss: '' } :
                                                            {};
                                                    setFormData(prevFormData => ({
                                                        ...prevFormData,
                                                        recovery_status: selected.value,
                                                        additional_information: {}
                                                    }));
                                                }}
                                                value={recoveryStatus.find(option => option.value == formData.recovery_status) || ''}
                                            />
                                        </Form.Group>
                                    </div>


                                    {formData?.recovery_status === '1' ? (
                                        <>
                                            <Form.Group controlId="exampleForm.ControlInput1" className='col-md-6' >
                                                <Form.Label>When was the ULD found ?</Form.Label>
                                                <Form.Control className='mb-2' type="datetime-local" name='additional_information.date_time' value={formData.additional_information?.date_time} onChange={onChangesData} />
                                                <Form.Label>How was the ULD found ?</Form.Label>
                                                <Select
                                                    options={optionHowFound}
                                                    placeholder="Please Select"
                                                    className='rfs_autoslct mb-2'
                                                    name="additional_information.how_found"
                                                    onChange={(selected) => {
                                                        const updatedData = {
                                                            ...formData,
                                                            additional_information: {
                                                                ...formData.additional_information,
                                                                how_found: selected.value
                                                            }
                                                        };
                                                        setFormData(updatedData);
                                                    }}
                                                    value={optionHowFound.find(option => option.value == formData.additional_information.how_found) || ''}
                                                />
                                                <Form.Label>Current condition of the ULD</Form.Label>
                                                <Select
                                                    options={optionCondition}
                                                    placeholder="Please Select"
                                                    className='rfs_autoslct'
                                                    name="additional_information.condition"
                                                    onChange={(selected) => {
                                                        const updatedData = {
                                                            ...formData,
                                                            additional_information: {
                                                                ...formData.additional_information,
                                                                condition: selected.value
                                                            }
                                                        };
                                                        setFormData(updatedData);
                                                    }}
                                                    value={optionCondition.find(option => option.value == formData.additional_information.condition) || ''}
                                                />

                                            </Form.Group>
                                        </>
                                    ) : (formData?.recovery_status === '2' ? (
                                        <>
                                            <Form.Group controlId="exampleForm.ControlInput1" className='col-md-6' >
                                                <Form.Label>Circumstances of Loss</Form.Label>
                                                <Select
                                                    options={cirLoss}
                                                    placeholder="Please Select"
                                                    className='rfs_autoslct mb-2'
                                                    name="additional_information.cir_loss"
                                                    onChange={(selected) => {
                                                        const updatedData = {
                                                            ...formData,
                                                            additional_information: {
                                                                ...formData.additional_information,
                                                                cir_loss: selected.value
                                                            }
                                                        };
                                                        setFormData(updatedData);
                                                    }}
                                                    value={cirLoss.find(option => option.value == formData.additional_information.cir_loss) || ''}
                                                />

                                                <Form.Label>Confirmation of Loss</Form.Label>
                                                <Select
                                                    options={conLoss}
                                                    placeholder="Please Select"
                                                    className='rfs_autoslct mb-2'
                                                    name="additional_information.conf_loss"
                                                    onChange={(selected) => {
                                                        const updatedData = {
                                                            ...formData,
                                                            additional_information: {
                                                                ...formData.additional_information,
                                                                conf_loss: selected.value
                                                            }
                                                        };
                                                        setFormData(updatedData);
                                                    }}
                                                    value={conLoss.find(option => option.value == formData.additional_information.conf_loss) || ''}
                                                />
                                            </Form.Group>
                                        </>
                                    ) : (formData?.recovery_status === '3' ? (
                                        <>
                                            <Form.Group controlId="exampleForm.ControlInput1" className='col-md-6' >
                                                <Form.Label>Flight/Truck</Form.Label>
                                                <Select
                                                    options={TruckFlightList}
                                                    placeholder="Please Select"
                                                    className='rfs_autoslct mb-2'
                                                    name="additional_information.flight_or_truck"
                                                    onChange={(selected) => {
                                                        const updatedData = {
                                                            ...formData,
                                                            additional_information: {
                                                                ...formData.additional_information,
                                                                flight_or_truck: selected.value
                                                            }
                                                        };
                                                        setFormData(updatedData);
                                                    }}
                                                    value={TruckFlightList.find(option => option.value == formData.additional_information.flight_or_truck) || ''}
                                                />

                                                <Form.Label>Destination Flight/Truck</Form.Label>

                                                <Select
                                                    options={getDestination}
                                                    onChange={(selected) => {
                                                        const selectedDestination = getDestination.find(option => option.value === selected.value);
                                                        // const updatedData = { ...formData, destination: selected.value, handler_name: '' };
                                                        const updatedData = {
                                                            ...formData,
                                                            additional_information: {
                                                                ...formData.additional_information,
                                                                destination: selected.value
                                                            }
                                                        };
                                                        setFormData(updatedData);

                                                    }}
                                                    placeholder="Destination"
                                                    className='autoslct mb-2'
                                                    name="additional_information.destination"
                                                    value={getDestination.find(option => option.value === formData.additional_information?.destination) || ''}
                                                />
                                                <Form.Label>Date of Flight/Truck</Form.Label>
                                                <Form.Control className='mb-2' type="datetime-local" name='additional_information.date_time' value={formData.additional_information?.date_time} onChange={onChangesData} />



                                                <Form.Label>Airway Bill Reference</Form.Label>
                                                <Form.Control type="text" name="additional_information.airway_bill_ref" onChange={onChangesData} />


                                            </Form.Group>
                                        </>
                                    ) : (formData?.recovery_status === '4' ? (
                                        <>
                                            <Form.Group controlId="exampleForm.ControlInput1" className='col-md-6' >
                                                <Form.Label>Receiving Handler Station </Form.Label>
                                                <Select
                                                    options={getDestination}
                                                    onChange={(selected) => {
                                                        const selectedDestination = getDestination.find(option => option.value === selected.value);
                                                        // const updatedData = { ...formData, rec_handler_station: selected.value, handler_name: '' };
                                                        const updatedData = {
                                                            ...formData,
                                                            additional_information: {
                                                                ...formData.additional_information,
                                                                rec_handler_station: selected.value
                                                            }
                                                        };
                                                        setFormData(updatedData);

                                                    }}
                                                    placeholder="Handler Station"
                                                    className='autoslct'
                                                    name="additional_information.rec_handler_station"
                                                    value={getDestination.find(option => option.value === formData.additional_information?.rec_handler_station)}
                                                />
                                                <Form.Label>Receiving Handler </Form.Label>
                                                <Form.Control type="text" name="additional_information.reciving_handler" onChange={onChangesData} />

                                                <Form.Label>Date/Time of Transfer </Form.Label>
                                                <Form.Control className='mb-2' type="datetime-local" name='additional_information.trans_date_time' value={formData.additional_information?.trans_date_time} onChange={onChangesData} />
                                            </Form.Group>
                                        </>
                                    ) : (formData?.recovery_status === '5' ? (
                                        <>
                                            <Form.Group controlId="exampleForm.ControlInput1" className='col-md-6' >
                                                <Form.Label>Date/Time Returned </Form.Label>
                                                <Form.Control className='mb-2' type="datetime-local" name='additional_information.return_date_time' value={formData.additional_information?.trans_date_time} onChange={onChangesData} />
                                                <Form.Label>Station </Form.Label>
                                                <Select
                                                    options={getDestination}
                                                    onChange={(selected) => {
                                                        const selectedDestination = getDestination.find(option => option.value === selected.value);
                                                        // const updatedData = { ...formData, station: selected.value, handler_name: '' };
                                                        const updatedData = {
                                                            ...formData,
                                                            additional_information: {
                                                                ...formData.additional_information,
                                                                station: selected.value
                                                            }
                                                        };
                                                        setFormData(updatedData);

                                                    }}
                                                    placeholder="Station"
                                                    className='autoslct'
                                                    name="additional_information.station"
                                                    value={getDestination.find(option => option.value === formData.additional_information?.station)}
                                                />
                                                <Form.Label> Handler </Form.Label>
                                                <Form.Control type="text" name="additional_information.handler" onChange={onChangesData} />
                                            </Form.Group>
                                        </>
                                    ) : (formData?.recovery_status === '6' ? (
                                        <>
                                            <Form.Group controlId="exampleForm.ControlInput1" className='col-md-6' >
                                                <Form.Label>Name of External Party </Form.Label>
                                                <Form.Control type="text" name="additional_information.location_external_party" onChange={onChangesData} />
                                                <Form.Label>Location External Party </Form.Label>
                                                <Form.Control type="text" name="additional_information.location_external_party" onChange={onChangesData} />
                                                <Form.Label>Date/Time to ecternal party </Form.Label>
                                                <Form.Control className='mb-2' type="datetime-local" name='additional_information.date_time' value={formData.additional_information?.date_time} onChange={onChangesData} />
                                                <Form.Label>Purpose of delivery  </Form.Label>
                                                <Select
                                                    options={deliverypurpose}
                                                    placeholder="Purpose of delivery"
                                                    className='rfs_autoslct'
                                                    name="additional_information.delivery_purpose"
                                                    onChange={(selected) => {
                                                        const updatedData = {
                                                            ...formData,
                                                            additional_information: {
                                                                ...formData.additional_information,
                                                                delivery_purpose: selected.value
                                                            }
                                                        };
                                                        setFormData(updatedData);
                                                    }}
                                                    value={deliverypurpose.find(option => option.value === formData.delivery_purpose?.station) || ''}
                                                />
                                                <Form.Label>Shipment Referencey </Form.Label>
                                                <Form.Control type="text" name="additional_information.shihment_ref" onChange={onChangesData} />
                                            </Form.Group>
                                        </>
                                    ) : (formData?.recovery_status === '7') ? (
                                        <>
                                            <Form.Group controlId="exampleForm.ControlInput1" className='col-md-6' >
                                                <Form.Label>What happend with the ULD ? </Form.Label>
                                                <Form.Control type="text" name="additional_information.what_happened_uld" onChange={onChangesData} />
                                            </Form.Group>
                                        </>
                                    ) : '')))))}


                                </div>

                            </div>

                        </Col>
                        <Col sm='4'>
                            <div className='missing_info'>
                                <h4>Extra Information</h4>
                                <p>Provide Additional Remarks and Documents</p>

                                <div className='charter_from'>
                                    <Form.Group className="mb-1" >
                                        <Form.Label>Remarks </Form.Label>
                                        <Form.Control as="textarea" name='remarks' style={{ height: '145px' }} onChange={onChangesData} />
                                    </Form.Group>
                                    <Form.Group >

                                        <div className='d-flex align-items-center'>
                                            <div>
                                                <Form.Label>Upload Documents/Images </Form.Label>
                                                <div
                                                    className="drop_new"
                                                    onDrop={handleDrop}
                                                    onDragOver={handleDragOver}
                                                >
                                                    <h3>Drag and drop files here</h3>
                                                    <button className='btn btn-primary drpbtn' onClick={handleBrowseFiles}>Browse Files</button>
                                                    <span>Maximum file size 4 MB</span>
                                                    <input
                                                        type="file"
                                                        ref={fileInputRef}
                                                        style={{ display: 'none' }}
                                                        onChange={handleFileChange}
                                                        multiple
                                                    />
                                                </div>
                                            </div>
                                            <div className='d-flex upimg_repair'>
                                                {files.map((file, index) => (
                                                    <div key={index} className='img-thumbnail'>
                                                        {file.type.startsWith('image/') ? (
                                                            <img
                                                                src={URL.createObjectURL(file)}
                                                                alt="Preview"
                                                                style={{ maxWidth: '40px', maxHeight: '40px', }}
                                                            />
                                                        ) : (
                                                            <span className='d-flex'><img src={Docmnt} className='fileimg' />  </span>
                                                        )}
                                                        <button className='dltbtn' type="button" onClick={() => handleDeleteFile(index)}> <FontAwesomeIcon icon={faCircleXmark} color='#656565' /></button>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </Form.Group>
                                </div>
                            </div>
                            <div className='missing_info mb-0'>
                                <h4>Contact Information</h4>
                                <p>Enter Essential Details</p>
                                <div className='charter_from'>
                                    <Row className="mb-2">
                                        <Col sm="6">
                                            <Form.Label className="form-label">Name</Form.Label>
                                            <Form.Control type="text" name="contact_person.name" onChange={onChangesData} />
                                        </Col>
                                        <Col sm="6">
                                            <Form.Label className="form-label">Department</Form.Label>
                                            <Form.Control type="text" name="contact_person.department" onChange={onChangesData} />
                                        </Col>
                                    </Row>

                                    <Row className="mb-2">
                                        <Col sm="6">
                                            <Form.Label className="form-label">Email Address</Form.Label>
                                            <Form.Control type="text" name="contact_person.email_address" onChange={onChangesData} />
                                        </Col>
                                        <Col sm="6">
                                            <Form.Label className="form-label">Telephone Number</Form.Label>
                                            <Form.Control type="text" name="contact_person.telephone_number" onChange={onChangesData} />
                                        </Col>
                                    </Row>


                                </div>


                            </div>
                        </Col>
                    </Row>
                    <div className='text-center mt-4'>
                        <Button className='stk_save' onClick={handleSubmitForm}> Submit </Button>
                    </div>
                </>
            )}
        </div>
    )
}

export default SubmitForm;